module.exports = __webpack_public_path__ + "static/img/ldt1.60e4b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ldt1.png
// module id = lyy7
// module chunks = 0